import type * as React from 'react';

import { cn } from '@/lib/utils';

export interface TimelineEntry {
  key: string;
  label: React.ReactNode;
  /** Heure ou date à droite, en mono `muted-foreground`. */
  time: React.ReactNode;
}

/** `timeline` : étapes datées (Créée, Démarrée, Terminée), puce 8px, heure à droite. */
function Timeline({
  entries,
  className,
}: {
  entries: readonly TimelineEntry[];
  className?: string;
}): React.JSX.Element {
  return (
    <ol className={cn('m-0 grid list-none p-0', className)}>
      {entries.map((entry) => (
        <li
          key={entry.key}
          className="grid grid-cols-[16px_1fr_auto] items-baseline gap-3 py-1.5 text-[13px] leading-[18px]"
        >
          <i aria-hidden="true" className="mx-1 mt-[5px] block size-2 rounded-full bg-foreground" />
          <span>{entry.label}</span>
          <span className="font-mono text-muted-foreground">{entry.time}</span>
        </li>
      ))}
    </ol>
  );
}

export { Timeline };
